import { PartialTranslation } from '../translations';

export const lt: PartialTranslation = {
  newChat: 'Naujas pokalbis',
  search: 'Ieškoti',
  user: 'Naudotojas',
  settings: 'Nustatymai',
  language: 'Kalba',
  getHelp: 'Gauti pagalbą',
  viewAllPlans: 'Peržiūrėti visus planus',
  learnMore: 'Sužinoti daugiau',
  logOut: 'Atsijungti',
  chooseLanguage: 'Bize lingvon',
  chooseYourPreferredLanguage: 'Bize vian preferatan lingvon',
  searchLanguages: 'Serĉi lingvojn...',
  autoDetect: 'Automatinis aptikimas',
  noLanguagesFound: 'Neniuj lingvoj trovitaj',
  askAnything: 'Klauskite bet ko',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Asmeninis',
  freePlan: 'Nemokamas planas',
  current: 'Nuna',
  close: 'Fermi',
  archive: 'Arkivigi',
  delete: 'Forigi',
  confirmDelete: 'Ĉu vi certas ke vi volas forigi ĉi tiun babilon?',
  confirmArchive: 'Ĉu vi certas ke vi volas arkivigi ĉi tiun babilon?',
  deleteCannotUndo: 'Ĉi tiu ago ne povas esti malfari.',
  archiveCanFind: 'Vi povas trovi ĝin en la arkiva listo post arkivigo.',
  
  // 资源面板
  resources: 'Ištekliai',
  addResource: 'Pridėti išteklių',
  deleteResource: 'Forigi rimedon',
  noMatchingResourcesFound: 'Neniuj kongruaj rimedoj trovitaj',
  noResourcesAvailable: 'Neniuj rimedoj disponeblaj',
  hideResources: 'Kaŝi rimedojn',
  showResources: 'Montri rimedojn',
  
  // 聊天输入框
  typeMessage: 'Rašyti žinutę...',
  thinkingOptions: 'Pensaj opcioj',
  deleteFile: 'Forigi dosieron',
  clearSelection: 'Viŝi selekton',
  addAttachment: 'Pridėti priedą',
  sendMessage: 'Siųsti žinutę',
  
  // 思考模式选项
  deepInsight: 'Profunda kompreno · Surfaca analizo',
  deepInsightDesc: 'Rapida kompreno de ŝlosilaj punktoj',
  deepExploration: 'Profunda esplorado · Ampleksa analizo',
  deepExplorationDesc: 'Multdimensia profunda esplorado',
  deepDeconstruction: 'Profunda malkonstruado · Sistema argumento',
  deepDeconstructionDesc: 'Tavolo post tavolo progresa analizo',
  
  // 写作模式选项
  contractReview: 'Kontrakta revizio · Risko identigo',
  contractReviewDesc: 'Klausola analizo kaj konformeca kontrolo',
  textPolish: 'Teksta poluro · Profesia esprimo',
  textPolishDesc: 'Lingva optimumigo kaj struktura alĝustigo',
  legalDocuments: 'Leĝaj dokumentoj · Norma malneto',
  legalDocumentsDesc: 'Profesia leĝa dokumento skribado',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Prisijungti',
  register: 'Registruotis',
  welcomeBack: 'Sveiki atvykę į LawHelper',
  loginSubtitle: 'Jūsų AI teisinis tyrimų asistentas',
  continueWithGoogle: 'Tęsti su Google',
  continueWithMicrosoft: 'Tęsti su Microsoft',
  continueWithWeChat: 'Tęsti su WeChat',
  orContinueWith: 'arba tęsti su',
  emailTab: 'El. paštas',
  phoneTab: 'Telefonas',
  emailPlaceholder: 'Įveskite savo el. paštą',
  phonePlaceholder: 'Įveskite telefono numerį',
  codePlaceholder: 'Įveskite 6 skaitmenų kodą',
  sending: 'Siunčiama...',
  verifying: 'Tikrinama...',
  verify: 'Patvirtinti',
  sendMagicLink: 'Siųsti stebuklingą nuorodą',
  getVerificationCode: 'Gauti kodą',
  resendCode: 'Siųsti kodą iš naujo',
  resendIn: 'Siųsti iš naujo po',
  magicLinkSent: 'Stebuklinga nuoroda išsiųsta į jūsų el. paštą',
  magicLinkHint: 'Išsiųsime saugią nuorodą į jūsų el. paštą',
  otpSent: 'Patvirtinimo kodas išsiųstas',
  agreeToTerms: 'Tęsdami sutinkate su mūsų',
  privacyPolicy: 'Privatumo politika',
  termsOfService: 'Paslaugų teikimo sąlygos',
  and: 'ir',
  privacyTitle: 'Jūsų privatumas yra svarbus',
  privacyIntro: 'Naudojame slapukus ir panašias technologijas, kad suteiktume geriausią patirtį.',
  essentialCookies: 'Būtinieji slapukai',
  essentialDesc: 'Būtini svetainės veikimui',
  analyticsCookies: 'Analitiniai slapukai',
  analyticsDesc: 'Padeda mums tobulinti paslaugą',
  marketingCookies: 'Rinkodaros slapukai',
  marketingDesc: 'Naudojami personalizuotam turiniui',
  acceptAll: 'Priimti visus',
  essentialOnly: 'Tik būtini',
  customize: 'Pritaikyti',
  savePreferences: 'Išsaugoti nustatymus',
  back: 'Atgal',
  readPrivacyPolicy: 'Perskaitykite mūsų privatumo politiką',
  cookiePolicy: 'Slapukų politika',
  gdprCompliance: 'BDAR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI peržiūra',
  aiDraft: 'AI juodraštis',
  smartAssistant: 'Šablonas',

  // 知识库搜索
  enableKnowledgeSearch: 'Įjungti paiešką',
  knowledgeSearchDesc: 'AI ieško jūsų dokumentuose',
  clickToDisable: 'Išjungti',
  clickToEnable: 'Įjungti',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Uždaryti išteklių skydelį',
  uploading: 'Įkeliama %{fileName}...',
  processing: 'Apdorojama %{fileName}...',
  uploadSuccess: '✓ %{fileName} įkelta',
  uploadError: '✗ Įkėlimas nepavyko: %{error}',
  quickAnswer: 'Greitas atsakymas',
  quickAnswerDesc: 'Greitas atsakymas į paprastus klausimus',
  cancelRequest: 'Atšaukti',
  library: 'Biblioteka',
  filterAll: 'Visi',
  filterChat: 'Pokalbiai',
  filterReview: 'Peržiūra',
  filterDraft: 'Juodraštis',
  filterTemplate: 'Šablonas',
  filterForm: 'Forma',
  thinking: 'Galvoju...',
  thinkingProcess: 'Mąstymo procesas',
  analyzingLegalLogic: 'Analizuojama teisinė logika...',
  lawhelperThinking: 'Lawhelper galvoja...',
  serviceError: 'Paslaugos klaida',
  uploaded: 'Įkelta',
  settingsGeneral: 'Bendri',
  settingsNotifications: 'Pranešimai',
  settingsAppearance: 'Išvaizda',
  settingsProfile: 'Profilis',
  settingsResponseNotifications: 'Atsakymų pranešimai',
  settingsResponseNotificationsDesc: 'Pranešimas baigus AI atsakymą',
  settingsColorMode: 'Spalvų režimas',
  settingsLight: 'Šviesus',
  settingsDark: 'Tamsus',
  settingsSystem: 'Sistema',
  about: 'Apie',
  reviewTitle: 'Dokumento peržiūra',
  exitReview: 'Išeiti iš peržiūros',
  uploadPrompt: 'Įkelkite PDF peržiūrai',
  uploadButton: 'Pasirinkti failą',
  startChatConfig: 'Įveskite "Peržiūrėti šį dokumentą"',
  reviewPlaceholder: 'Įveskite žinutę...',
  analyzing: 'Peržiūrima...',
  reviewComplete: 'Peržiūra baigta',
  issuesFound: 'Rasta %{count} problemų',
  draftTitle: 'Teisinio dokumento rengimas',
  draftPlaceholder: 'Redaguokite čia arba paprašykite AI...',
  analyzingTemplate: 'Analizuojamas šablonas %{name}...',
  templateAnalyzed: '✅ Šablonas %{name} išanalizuotas!',
  templateAnalysisPrompt: 'Analizuoti pagrindines sąlygas',
  parsingFailed: '⚠️ Nepavyko išanalizuoti failo.',
  generating: 'Generuojama...',
  generatedSuccess: '✅ Dokumentas sugeneruotas!',
  drafterWelcome: 'Sveiki atvykę į AI dokumentų asistentą',
  drafterYouCan: 'Galite:',
  drafterUploadTemplate: 'Įkelti šabloną AI analizei',
  drafterDescribeNeeds: 'Aprašyti dokumento reikalavimus',
  drafterLetAiHelp: 'AI padeda rengti sutartis, susitarimus ir kt.',
  drafterExamples: 'Pavyzdžiai:',
  drafterExampleRental: '"Parenkite nuomos sutartį"',
  drafterExampleLabor: '"Užpildykite darbo sutartį"',
  drafterInputPlaceholder: 'Aprašykite poreikius...',
  drafterThinking: 'Galvoju...',
  drafterHistoryTitle: 'Istorija',
  drafterNoHistory: 'Nėra istorijos',
  drafterNewChat: 'Naujas pokalbis',
  drafterHistory: 'Istorija',
  drafterRemoveAttachment: 'Pašalinti priedą',
  drafterLineHeight: 'Eilutės aukštis',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Eksportuoti kaip Word (.docx)',
  drafterExportPdf: 'Eksportuoti kaip PDF',
  drafterSave: 'Išsaugoti dokumentą',
  drafterDownload: 'Atsisiųsti dokumentą',
  drafterUndo: 'Atšaukti',
  drafterRedo: 'Pakartoti',
  drafterBold: 'Pusjuodis',
  drafterItalic: 'Kursyvas',
  drafterStrike: 'Perbrauktas',
  drafterUnderline: 'Pabrauktas',
  drafterHighlight: 'Paryškinti',
  drafterLink: 'Įterpti nuorodą',
  drafterAlignLeft: 'Kairėje',
  drafterAlignCenter: 'Centre',
  drafterAlignRight: 'Dešinėje',
  drafterAlignJustify: 'Abiejuose kraštuose',
  drafterList: 'Sąrašas',
  drafterBulletList: 'Ženklintas sąrašas',
  drafterOrderedList: 'Numeruotas sąrašas',
  drafterTaskList: 'Užduočių sąrašas',
  drafterOpenResource: 'Atidaryti išteklius',
  drafterStopGeneration: 'Sustabdyti generavimą',
  drafterAgentMode: 'Agento režimas aktyvus',
  drafterAgentModeOn: 'Agento režimas aktyvus',
  drafterAgentModeOff: 'Įprastas režimas',
  drafterUploadAttachment: 'Įkelti priedą',
  drafterExit: 'Išeiti',
  drafterConfirm: 'Patvirtinti',
  drafterOpenLink: 'Atidaryti nuorodą',
  drafterDeleteLink: 'Ištrinti nuorodą',
  drafterQuote: 'Citata',
  workflowTitle: 'AI darbo eiga',
  workflowRunning: 'Vykdoma...',
  workflowReady: 'Paruošta',
  workflowCompleted: 'Baigta',
  workflowStartFailed: 'Nepavyko paleisti',
  workflowExecutionFailed: 'Nepavyko vykdyti',
  workflowInterrupted: 'Darbo eiga nutraukta',
  workflowProcessing: 'Apdorojama...',
  workflowStepsCompleted: 'žingsnių baigta',
  workflowStepsTotal: 'Darbo eiga baigta (%{count} žingsnių)',
  acceptChanges: 'Priimti pakeitimus',
  rejectChanges: 'Atmesti pakeitimus',
  changesAccepted: 'Pakeitimai priimti',
  changesRejected: 'Pakeitimai atmesti',
  stopWorkflow: 'Sustabdyti',
  restartWorkflow: 'Paleisti iš naujo',
  startDrafting: 'Pradėti rengimą',
  interrupt: 'Sustabdyti',
  documentSubject: 'Dokumento tema *',
  documentType: 'Dokumento tipas',
  jurisdiction: 'Jurisdikcija',
  specialRequirements: 'Specialūs reikalavimai (neprivaloma)',
  clickStartDrafting: 'Paspauskite "Pradėti rengimą"',
  docTypeContract: 'Sutartis',
  docTypeAgreement: 'Susitarimas',
  docTypeNotice: 'Pranešimas',
  docTypeLetter: 'Laiškas',
  docTypePetition: 'Peticija',
  docTypeWill: 'Testamentas',
  docTypePowerOfAttorney: 'Įgaliojimas',
  countryChina: 'Kinija',
  countryUSA: 'JAV',
  countryGermany: 'Vokietija',
  countryJapan: 'Japonija',
  countryFrance: 'Prancūzija',
  countryUK: 'Jungtinė Karalystė',
  citationVerified: 'Patvirtinta',
  citationUnverified: 'Nepatvirtinta',
  imageLoadFailed: 'Nepavyko įkelti vaizdo',
  smartDocTitle: 'Išmanusis dokumentų asistentas',
  smartDocChatTitle: 'AI dokumentų asistentas',
  smartDocDropPrompt: 'Numeskite PDF čia',
  smartDocSelectFile: 'Pasirinkti failą',
  smartDocOr: 'arba',
  smartDocWelcomeTitle: 'Sveiki atvykę į AI asistentą',
  smartDocWelcomeYouCan: 'Galite:',
  smartDocUploadForAI: 'Įkelti šabloną',
  smartDocDescribeDoc: 'Aprašyti reikalavimus',
  smartDocLetAIDraft: 'AI padeda su sutartimis',
  smartDocExamples: 'Pavyzdžiai:',
  smartDocExampleRental: '"Parenkite nuomos sutartį"',
  smartDocExampleLabor: '"Užpildykite darbo sutartį"',
  smartDocInputPlaceholder: 'Aprašykite poreikius...',
  smartDocRemoveAttachment: 'Pašalinti priedą',
  smartDocOpenResources: 'Atidaryti išteklius',
  smartDocExit: 'Išeiti',
  reviewStartFailed: 'Nepavyko paleisti peržiūros',
  reviewFailed: 'Peržiūra nepavyko',
  reviewFoundIssues: 'Peržiūra baigta, %{count} problemų.',
  cannotReadStream: 'Negalima skaityti srauto',
  parseEventFailed: 'Nepavyko analizuoti įvykio',
  errorPrefix: 'Klaida',
  unknownError: 'Nežinoma klaida',
  file: 'Failas',
  loading: 'Kraunama...',
  localFolders: 'Vietiniai aplankai',
  selectLocalFolder: 'Pasirinkti vietinį aplanką',
  reselectFolder: 'Pakeisti aplanką',
  addToContext: 'Pridėti prie pokalbio',
  saveFile: 'Išsaugoti',
  renameFile: 'Pervardyti',
  fileSaved: 'Failas išsaugotas',
  fileRenamed: 'Failas pervardintas į %{name}',
  browserNotSupported: 'Naršyklė nepalaiko prieigos prie aplankų',
  noFolderSelected: 'Pasirinkite vietinį aplanką',
  scanningFolder: 'Skenuojamas aplankas...',
  selectFileToPreview: 'Pasirinkite failą peržiūrai',
  aiAnalyze: 'AI analizė',
};
